import { combineReducers } from 'redux';

import sellPoints from './sellPoints';
import categories from './categories';
import items from './items';
import kits from './kits';
import options from './options';

export default combineReducers({ sellPoints, categories, items, kits, options });
